module.exports = __webpack_public_path__ + "img/pattern-tile-1.777a3213.png";